<template>
  <x-page title="首页" :loading="loading">
    <template v-if="!loading">
      <div>ddd</div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '首页',
      })),
    ],

    computed: {
      loading() {
        return false
      },
    },
  })
</script>

<style lang="scss" module></style>
